import { Button } from '@bedrock/ui/button';

interface FormStatusOverlayProps {
  status: 'idle' | 'success' | 'error';
  successTitle?: string;
  successMessage?: string;
  errorTitle?: string;
  errorMessage?: string;
  closeLabel?: string;
  onClose: () => void;
}

export function FormStatusOverlay({
  status,
  successTitle,
  successMessage,
  errorTitle,
  errorMessage,
  closeLabel,
  onClose,
}: Readonly<FormStatusOverlayProps>) {
  if (status === 'success') {
    return (
      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 bg-[rgba(0,0,0,.75)] text-center">
        <span className="br-type-title-3xl md:br-type-title-5xl text-foreground">
          {successTitle || 'SUCCESS'}
        </span>
        <span className="br-type-body-md text-foreground">{successMessage || 'Thank you!'}</span>
        <Button className="br-type-button-md text-foreground" onClick={onClose}>
          {closeLabel ?? 'CLOSE'}
        </Button>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 bg-[rgba(0,0,0,.75)] text-center">
        <span className="br-type-title-3xl md:br-type-title-5xl text-foreground">
          {errorTitle || 'ERROR'}
        </span>
        <span className="br-type-body-md text-foreground">
          {errorMessage || 'Something went wrong. Please try again.'}
        </span>
        <Button className="br-type-button-md text-foreground" onClick={onClose}>
          {closeLabel ?? 'CLOSE'}
        </Button>
      </div>
    );
  }

  return null;
}
